
import {
    INIT_BRANCH_LIST_INFO,

    REQUEST_BRANCH_DETAIL_FAIL,
    REQUEST_BRANCH_DETAIL_START,
    REQUEST_BRANCH_DETAIL_SUCCESS,

    SEARCH_BRANCH_LIST_START,
    SEARCH_BRANCH_LIST_SUCCESS,
    SEARCH_BRANCH_LIST_FAIL,

    REQUEST_BRANCH_LIST_START,
    REQUEST_BRANCH_LIST_SUCCESS,
    REQUEST_BRANCH_LIST_FAIL,

    REQUEST_BRANCH_CATE_FAIL,
    REQUEST_BRANCH_CATE_START,
    REQUEST_BRANCH_CATE_SUCCESS,

    REQUEST_LIST_CATE_BRANCH_START,
    REQUEST_LIST_CATE_BRANCH_SUCCESS,
    REQUEST_LIST_CATE_BRANCH_FAIL,

    ADD_BRANCH_CATE_START,
    ADD_BRANCH_CATE_SUCCESS,
    ADD_BRANCH_CATE_FAIL,

    DELETE_BRANCH_CATE_START,
    DELETE_BRANCH_CATE_SUCCESS,
    DELETE_BRANCH_CATE_FAIL,

    ADD_MAP_CATE_BRANCH_FAIL,
    ADD_MAP_CATE_BRANCH_START,
    ADD_MAP_CATE_BRANCH_SUCCESS,

    DELETE_MAP_CATE_BRANCH_FAIL,
    DELETE_MAP_CATE_BRANCH_START,
    DELETE_MAP_CATE_BRANCH_SUCCESS,

    MAP_PRODUCT_BRANCH_DETAIL_FAIL,
    MAP_PRODUCT_BRANCH_DETAIL_START,
    MAP_PRODUCT_BRANCH_DETAIL_SUCCESS,

    MAP_PRODUCT_BRANCH_FAIL,
    MAP_PRODUCT_BRANCH_START,
    MAP_PRODUCT_BRANCH_SUCCESS,

    MAP_PRODUCT_BRANCH_LIST_FAIL,
    MAP_PRODUCT_BRANCH_LIST_START,
    MAP_PRODUCT_BRANCH_LIST_SUCCESS,

    IMPORT_PRODUCT_BRANCH_FAIL,
    IMPORT_PRODUCT_BRANCH_START,
    IMPORT_PRODUCT_BRANCH_SUCCESS,

    REQUEST_IMPORT_PRODUCT_BRANCH_FAIL,
    REQUEST_IMPORT_PRODUCT_BRANCH_START,
    REQUEST_IMPORT_PRODUCT_BRANCH_SUCCESS,

    REQUEST_LIST_BRANCH_PRODUCT_START,
    REQUEST_LIST_BRANCH_PRODUCT_SUCCESS,
    REQUEST_LIST_BRANCH_PRODUCT_FAIL,

    REQUEST_LIST_BRANCH_FILTER_FAIL,
    REQUEST_LIST_BRANCH_FILTER_START,
    REQUEST_LIST_BRANCH_FILTER_SUCCESS,

    REQUEST_BRANCH_LIST_HIERARCHY_START,
    REQUEST_BRANCH_LIST_HIERARCHY_SUCCESS,
    REQUEST_BRANCH_LIST_HIERARCHY_FAIL,

    REQUEST_BRANCH_TYPE_LIST_START,
    REQUEST_BRANCH_TYPE_LIST_SUCCESS,
    REQUEST_BRANCH_TYPE_LIST_FAIL,

    REQUEST_BRANCH_TAG_LIST_START,
    REQUEST_BRANCH_TAG_LIST_SUCCESS,
    REQUEST_BRANCH_TAG_LIST_FAIL,

    REQUEST_BRANCH_CATEGORY_LIST_START,
    REQUEST_BRANCH_CATEGORY_LIST_SUCCESS,
    REQUEST_BRANCH_CATEGORY_LIST_FAIL,

    REQUEST_BRANCH_ACTIVE_LIST_START,
    REQUEST_BRANCH_ACTIVE_LIST_SUCCESS,
    REQUEST_BRANCH_ACTIVE_LIST_FAIL,

    REQUEST_BRANCH_PAGE_LIST_START,
    REQUEST_BRANCH_PAGE_LIST_SUCCESS,
    REQUEST_BRANCH_PAGE_LIST_FAIL,

    REQUEST_PAGE_ADD_BRANCH_START,
    REQUEST_PAGE_ADD_BRANCH_SUCCESS,
    REQUEST_PAGE_ADD_BRANCH_FAIL,

    REQUEST_PAGE_DELETE_BRANCH_START,
    REQUEST_PAGE_DELETE_BRANCH_SUCCESS,
    REQUEST_PAGE_DELETE_BRANCH_FAIL,

    REQUEST_UPDATE_PAGE_BRANCH_START,

} from '../actions/branch';


export const initialState = { error: null, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {

    const { type, data, payload, error } = action;

    switch (type) {

        case REQUEST_BRANCH_DETAIL_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_BRANCH_DETAIL_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_BRANCH_DETAIL_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case SEARCH_BRANCH_LIST_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case SEARCH_BRANCH_LIST_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case SEARCH_BRANCH_LIST_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_BRANCH_LIST_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_BRANCH_LIST_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_BRANCH_LIST_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }


        case REQUEST_BRANCH_CATE_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_BRANCH_CATE_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_BRANCH_CATE_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------


        case REQUEST_LIST_CATE_BRANCH_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_LIST_CATE_BRANCH_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_LIST_CATE_BRANCH_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case ADD_BRANCH_CATE_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case ADD_BRANCH_CATE_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case ADD_BRANCH_CATE_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case DELETE_BRANCH_CATE_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case DELETE_BRANCH_CATE_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case DELETE_BRANCH_CATE_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case ADD_MAP_CATE_BRANCH_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case ADD_MAP_CATE_BRANCH_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case ADD_MAP_CATE_BRANCH_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------


        case DELETE_MAP_CATE_BRANCH_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case DELETE_MAP_CATE_BRANCH_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case DELETE_MAP_CATE_BRANCH_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case MAP_PRODUCT_BRANCH_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case MAP_PRODUCT_BRANCH_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case MAP_PRODUCT_BRANCH_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case MAP_PRODUCT_BRANCH_DETAIL_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case MAP_PRODUCT_BRANCH_DETAIL_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case MAP_PRODUCT_BRANCH_DETAIL_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case MAP_PRODUCT_BRANCH_LIST_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case MAP_PRODUCT_BRANCH_LIST_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case MAP_PRODUCT_BRANCH_LIST_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------


        case IMPORT_PRODUCT_BRANCH_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case IMPORT_PRODUCT_BRANCH_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case IMPORT_PRODUCT_BRANCH_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------


        case REQUEST_IMPORT_PRODUCT_BRANCH_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_IMPORT_PRODUCT_BRANCH_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_IMPORT_PRODUCT_BRANCH_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case REQUEST_LIST_BRANCH_PRODUCT_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_LIST_BRANCH_PRODUCT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_LIST_BRANCH_PRODUCT_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case REQUEST_LIST_BRANCH_FILTER_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_LIST_BRANCH_FILTER_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_LIST_BRANCH_FILTER_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case REQUEST_BRANCH_LIST_HIERARCHY_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_BRANCH_LIST_HIERARCHY_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { branchHierarchyInfo: { ...data, ...payload?.res }, isLoading: false, type } }
            }

        case REQUEST_BRANCH_LIST_HIERARCHY_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case REQUEST_BRANCH_ACTIVE_LIST_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }
        case REQUEST_BRANCH_ACTIVE_LIST_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { branchActiveInfo: { ...data, ...payload?.res }, isLoading: false, type } }
            }
        case REQUEST_BRANCH_ACTIVE_LIST_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case REQUEST_BRANCH_PAGE_LIST_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }
        case REQUEST_BRANCH_PAGE_LIST_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { branchPageInfo: { ...data, ...payload?.res }, isLoading: false, type } }
            }
        case REQUEST_BRANCH_PAGE_LIST_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case REQUEST_BRANCH_TAG_LIST_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }
        case REQUEST_BRANCH_TAG_LIST_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { branchTagInfo: { ...data, ...payload?.res }, isLoading: false, type } }
            }
        case REQUEST_BRANCH_TAG_LIST_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case REQUEST_BRANCH_CATEGORY_LIST_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }
        case REQUEST_BRANCH_CATEGORY_LIST_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { branchCategoryInfo: { ...data, ...payload?.res }, isLoading: false, type } }
            }
        case REQUEST_BRANCH_CATEGORY_LIST_FAIL:

            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case REQUEST_BRANCH_TYPE_LIST_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }
        case REQUEST_BRANCH_TYPE_LIST_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { branchTypeInfo: { ...data, ...payload?.res }, isLoading: false, type } }
            }
        case REQUEST_BRANCH_TYPE_LIST_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case REQUEST_PAGE_ADD_BRANCH_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_PAGE_ADD_BRANCH_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_PAGE_ADD_BRANCH_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case REQUEST_PAGE_DELETE_BRANCH_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_PAGE_DELETE_BRANCH_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_PAGE_DELETE_BRANCH_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        // ----------------------------------------

        case REQUEST_UPDATE_PAGE_BRANCH_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        // ----------------------------------------


        case INIT_BRANCH_LIST_INFO:
            {
                return initialState;
            }

        default:
            {
                return { ...state };
            }
    }
};

export default reducer;






